export enum CellRendererType {
  VIDEO = 'VIDEO',
  IMAGE = 'IMAGE',
}
